"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _auth0Js = require("auth0-js");
var _authSelectors = require("./authSelectors");
var _authActions = require("./authActions");
var _LocalAuthStore = _interopRequireDefault(require("./LocalAuthStore"));
var _helpers = require("./helpers");
var AuthClient = exports.default = /*#__PURE__*/function () {
  function AuthClient(options, _temp) {
    var _this = this;
    var _ref = _temp === void 0 ? {} : _temp,
      store = _ref.store,
      _ref$preserveState = _ref.preserveState,
      preserveState = _ref$preserveState === void 0 ? true : _ref$preserveState;
    this.client = void 0;
    this.localStore = void 0;
    this.store = void 0;
    this.unsubscribeFromStore = null;
    this.subscribed = false;
    this.session = null;
    this.preserveState = true;
    this.onStateChange = function () {
      var oldSession = _this.session;
      var newSession = (0, _authSelectors.sessionSelector)(_this.store.getState());
      if (oldSession !== newSession) {
        _this.setSession(newSession);
        if (_this.preserveState) {
          _this.setLocalSession(newSession);
        }
      }
    };
    this.client = new _auth0Js.WebAuth(options);
    this.localStore = new _LocalAuthStore.default(options.clientID);
    this.store = store;
    this.session = (0, _authSelectors.sessionSelector)(store.getState());
    this.preserveState = preserveState;
  }
  var _proto = AuthClient.prototype;
  _proto.subscribe = function subscribe() {
    if (this.unsubscribeFromStore == null) {
      var session = (0, _authSelectors.sessionSelector)(this.store.getState());
      if (session != null) {
        this.setSession(session);
        if (this.preserveState) {
          this.setLocalSession(session);
        }
      }
      this.unsubscribeFromStore = this.store.subscribe(this.onStateChange);
    }
  };
  _proto.unsubscribe = function unsubscribe() {
    if (this.unsubscribeFromStore != null) {
      this.unsubscribeFromStore();
      this.unsubscribeFromStore = null;
    }
  };
  _proto.getSession = function getSession() {
    return this.session;
  };
  _proto.setSession = function setSession(session) {
    this.session = session;
  };
  _proto.getLocalSession = function getLocalSession() {
    return this.localStore.get('session');
  };
  _proto.setLocalSession = function setLocalSession(session) {
    if (session === void 0) {
      session = null;
    }
    if (session == null) {
      this.localStore.delete('session');
    } else {
      this.localStore.set('session', session);
    }
  };
  _proto.isAuthenticated = function isAuthenticated() {
    var session = this.getSession();
    return session != null && (0, _helpers.hasSessionExpired)(session) === false;
  };
  _proto.restoreLocalSession = function restoreLocalSession() {
    var localSession = this.getLocalSession();
    if (localSession != null && !(0, _helpers.hasSessionExpired)(localSession)) {
      this.store.dispatch((0, _authActions.authRequestSuccess)(localSession));
    }
  };
  _proto.handleAuthentication = function handleAuthentication(callback) {
    var _this2 = this;
    this.store.dispatch((0, _authActions.authRequest)());
    this.client.parseHash(function (err, result) {
      if (err) {
        _this2.store.dispatch((0, _authActions.authRequestError)(err));
      } else {
        _this2.store.dispatch((0, _authActions.authRequestSuccess)(Object.assign({}, result, {
          expiresAt: (0, _helpers.calculateExpiration)(result)
        })));
      }
      if (callback != null) {
        callback(err, result);
      }
    });
  };
  _proto.login = function login(options) {
    this.client.authorize(options);
  };
  _proto.logout = function logout(options) {
    if (options === void 0) {
      options = {};
    }
    this.localStore.clear();
    this.client.logout(options);
  };
  _proto.renewToken = function renewToken(callback) {
    var _this3 = this;
    this.client.checkSession({}, function (err, result) {
      if (err) {
        _this3.store.dispatch((0, _authActions.authRequestError)(err));
      } else {
        _this3.store.dispatch((0, _authActions.authRequestSuccess)(Object.assign({}, result, {
          expiresAt: (0, _helpers.calculateExpiration)(result)
        })));
      }
      if (callback != null) {
        callback(err, result);
      }
    });
  };
  return AuthClient;
}();